import { FC } from 'react';
import { UnorderedList } from '@chakra-ui/react';

type Props = {
  h?: string;
  children: React.ReactNode;
};

/**
 * 各ページのリスト表示部分を共通化するコンポーネント
 */
export const ListView: FC<Props> = ({ h = '60vh', children }) => (
  <UnorderedList h={h} ml="0" overflowY="scroll" overflowX="hidden">
    {children}
  </UnorderedList>
);
